import React from "react";
import { LogoStyled } from "./styles/Styled";

const logos = ["2x.png", "3x.png", "4x.png"];
const resolutions = [1920, 4096, 8192];

export default ({ width, height }) => {
  let renderLogo =
    window.innerWidth <= resolutions[0]
      ? logos[0]
      : resolutions[0] <= window.innerWidth <= resolutions[1]
      ? logos[1]
      : resolutions[1] >= window.innerWidth
      ? logos[2]
      : logos[1];

  return <LogoStyled src={`/images/${renderLogo}`} alt="Logo" width={width} height={height} />;
};
